import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';

export const ANOTACION_PROYECTO = 'gitlab.com/project-id';

export type Pipeline = {
  id: number;
  iid: number;
  status: string;
  ref: string;
  sha: string;
  source: string;
  created_at: string;
  updated_at: string;
  web_url: string;
};

export type Job = {
  id: number;
  name: string;
  stage: string;
  status: string;
  duration: number | null;
  started_at: string | null;
  finished_at: string | null;
  allow_failure: boolean;
  web_url: string;
};

export type RespuestaPipelines = {
  proyecto: { id: number; path_with_namespace: string; web_url: string };
  ramas: string[];
  pipelines: Pipeline[];
};

/** Cliente del plugin de backend vanti-gitlab (packages/backend/src/plugins/vantiGitlab). */
export class VantiGitlabApi {
  constructor(
    private readonly discovery: DiscoveryApi,
    private readonly fetch: FetchApi,
  ) {}

  private async get(ruta: string) {
    const base = await this.discovery.getBaseUrl('vanti-gitlab');
    const res = await this.fetch.fetch(`${base}${ruta}`);
    if (!res.ok) {
      const cuerpo = await res.json().catch(() => ({}));
      throw new Error(cuerpo.error ?? `Error ${res.status} consultando GitLab`);
    }
    return res;
  }

  async pipelines(projectId: string, ref?: string) {
    const qs = ref ? `?ref=${encodeURIComponent(ref)}` : '';
    const res = await this.get(`/projects/${projectId}/pipelines${qs}`);
    return (await res.json()) as RespuestaPipelines;
  }

  async jobs(projectId: string, pipelineId: number) {
    const res = await this.get(
      `/projects/${projectId}/pipelines/${pipelineId}/jobs`,
    );
    return (await res.json()) as Job[];
  }

  async log(projectId: string, jobId: number) {
    const res = await this.get(`/projects/${projectId}/jobs/${jobId}/trace`);
    return limpiarLog(await res.text());
  }
}

/** Quita códigos ANSI y marcadores de sección del log de GitLab. */
export function limpiarLog(texto: string) {
  return (
    texto
      // eslint-disable-next-line no-control-regex
      .replace(/\u001b\[[0-9;]*[A-Za-z]/g, '')
      .replace(/section_(start|end):\d+:[^\r\n]*?\r/g, '')
      .replace(/\r(?!\n)/g, '\n')
  );
}

export function duracion(segundos?: number | null) {
  if (segundos === null || segundos === undefined) return '—';
  const s = Math.round(segundos);
  const m = Math.floor(s / 60);
  return m ? `${m}m ${s % 60}s` : `${s}s`;
}

export const ESTADOS_ACTIVOS = [
  'created',
  'waiting_for_resource',
  'preparing',
  'pending',
  'running',
];
